import { createRouter, createWebHistory } from 'vue-router';
import { GetRouteDataByUrl, RouteUrlList, type IRouteUrlListElement } from '@/libs/RouteList';
import { useClientStore } from '@/stores/modules/clientInfo';
import * as ApiInstance from '@/libs/ApiClient';
import API from '@/api';
import isMobile from 'ismobilejs';
import * as Common from '@/libs/Common';
const routes = [
    {
        //  首頁
        path: RouteUrlList.Index.path,
        name: RouteUrlList.Index.name,
        component: () => import('@/components/0_Index/0_Index.vue')
    },
    {
        //  登入頁
        path: RouteUrlList.Login.path,
        name: RouteUrlList.Login.name,
        component: () => import('@/components/1_LoginPage/LoginPage.vue')
    },
    {
        //  基本身份驗證
        path: RouteUrlList.UserAuth.path,
        name: RouteUrlList.UserAuth.name,
        component: () => import('@/components/2_UserAuth/UserAuth.vue')
    },
    {
        //  契約
        path: RouteUrlList.Contract.path,
        name: RouteUrlList.Contract.name,
        component: () => import('@/components/3_Contract/Contract.vue')
    },
    {
        //  契約 P2
        path: RouteUrlList.RiskWarningContract.path,
        name: RouteUrlList.RiskWarningContract.name,
        component: () => import('@/components/4_RiskWarningContract/RiskWarningContract.vue')
    },

    {
        //  契約確認頁
        path: RouteUrlList.ContractConfirm.path,
        name: RouteUrlList.ContractConfirm.name,
        component: () => import('@/components/4_ContractConfirm/ContractConfirm.vue')
    },
    {
        //  身分證件上傳
        path: RouteUrlList.IdDocUpload.path,
        name: RouteUrlList.IdDocUpload.name,
        component: () => import('@/components/5_IdDocUpload/IdDocUpload.vue')
    },

    {
        //  出入金帳號約定/財力證明上傳
        path: RouteUrlList.ProofDocUpload.path,
        name: RouteUrlList.ProofDocUpload.name,
        component: () => import('@/components/6_ProofDocUpload/ProofDocUpload.vue')
    },
    {
        //  填寫基本資料
        path: RouteUrlList.FillBasicData.path,
        name: RouteUrlList.FillBasicData.name,
        component: () => import('@/components/7_FillBasicData/FillBasicData.vue')
    },
    {
        //  職務工作 + 投資經歷
        path: RouteUrlList.JobAssetInvestment.path,
        name: RouteUrlList.JobAssetInvestment.name,
        component: () => import('@/components/8_JobAssetInvestment/JobAssetInvestment.vue')
    },
    // TradingRiskScore
    {
        //  職務工作 + 投資經歷
        path: RouteUrlList.TradingRiskScore.path,
        name: RouteUrlList.TradingRiskScore.name,
        component: () => import('@/components/9_TradingRiskScore/TradingRiskScore.vue')
    },
    // 期貨交易知識認知確認表
    {
        path: RouteUrlList.FuturesKnowledge.path,
        name: RouteUrlList.FuturesKnowledge.name,
        component: () => import('@/components/10_FuturesKnowledge/FuturesKnowledge.vue')
    },
    //  資料確認頁
    {
        path: RouteUrlList.Confirmation.path,
        name: RouteUrlList.Confirmation.name,
        component: () => import('@/components/11_Confirmation/Confirmation.vue')
    },
    //  完成申請
    {
        path: RouteUrlList.Complete.path,
        name: RouteUrlList.Complete.name,
        component: () => import('@/components/12_Complete/Complete.vue')
    },
    //  完成申請
    {
        path: RouteUrlList.StatusOfApply.path,
        name: RouteUrlList.StatusOfApply.name,
        component: () => import('@/components/13_StatusOfApply/StatusOfApply.vue')
    },
    {
        path: RouteUrlList.StateError.path,
        name: RouteUrlList.StateError.name,
        component: () => import('@/components/StateError.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: () => import('@/components/0_Index/0_Index.vue')
    }
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
});
import { useLeaveProtectionStore } from '@/stores/modules/leaveProtection';
import useEsunMCA from '@/composables/useEsunMCA';

const esunMCA = useEsunMCA();
// 在這裡設置全局守衛
router.beforeEach(async (to, from, next) => {
    Common.ConsoleLog('[Debug]' + to.path);
    const currentPath = to.fullPath;
    const _targetPath = to.path.trim().toLowerCase();
    const routeData: IRouteUrlListElement = GetRouteDataByUrl(_targetPath);
    // 防止提開或刷新
    const leaveProtectionStore = useLeaveProtectionStore();
    if (routeData.leaveProtection === true) {
        leaveProtectionStore.setUnsavedChanges(true);
    } else {
        leaveProtectionStore.setUnsavedChanges(false);
    }

    // 錯誤頁skip下面登入判斷
    if (
        routeData.name === RouteUrlList.StateError.name ||
        _targetPath === RouteUrlList.StateError.path.trim().toLowerCase() ||
        routeData.name === RouteUrlList.Login.name ||
        _targetPath === RouteUrlList.Login.path.trim().toLowerCase()
    ) {
        next(); // 繼續導航
        return;
    }

    // window.scrollTo({ top: 0, behavior: 'smooth' });
    const store = useClientStore();
    let isLogin = store.isLogin.valueOf();
    if (!isLogin) {
        isLogin = await API.ServiceAlertLoginCheck(true); // 登入檢查
    }

    store.setRouteInit(true);
    store.setLoginState(isLogin.valueOf());
    store.setIsWebViewState(esunMCA.WebViewDetect()); // 判斷WebView
    store.setIsMobileState(isMobile(window.navigator).any);
    store.setIsLoaded(false);

    Common.ConsoleLog('[router.index] 路由 : ' + routeData?.name);
    ApiInstance.GetServiceAlertInstance().ClearIdleCheckTimeoutId();
    if (isLogin === false) {
        // redirect the user to the login page
        if (esunMCA.WebViewDetect()) {
            esunMCA.SendMessage(0, ApiInstance.defaultErrorMsg.disconnect);
            return;
        } else if (routeData.requiredLogin === true) {
            return next({
                name: RouteUrlList.Login.name,
                query: {
                    ...to.query
                    //timestamp: Date.now().toString() // 添加時間戳
                }
            });
        } else {
            next(); // 繼續導航
            return;
        }
    } else {
        next(); // 繼續導航
        return;
    }
});

router.afterEach((to, from) => {
    const store = useClientStore();
    store.setIsLoaded(true);
    // 頁面SEO優化 安全地設定 <link rel="canonical">
    SetCanonicalLink();
});

/**
 * @todo 頁面SEO優化
 * @param canonicalUrl
 * @returns
 */
function SetCanonicalLink(): boolean {
    try {
        const TRUSTED_HOSTS: RegExp[] = [/\.esunsec\.com\.tw$/, /\.testesunsec\.com\.tw$/];

        const origin: string = window.location.origin;
        const pathname: string = window.location.pathname;

        // 驗證 origin 來源
        const isValidOrigin: boolean = TRUSTED_HOSTS.some((hostRegex) => hostRegex.test(new URL(origin).hostname));
        const isValidPathname: boolean = /^\/[a-zA-Z0-9._~:/?#[\]@!$&'()*+,;=-]*$/.test(pathname);

        if (!isValidOrigin || !isValidPathname) {
            Common.ConsoleLog(`[router.index] Invalid Canonical URL detected will not set canonical link`);
            return false;
        }

        // 編碼canonicalUrl
        const canonicalUrl: string = encodeURI(origin + pathname).replace(/[\\"']/g, '');

        // 安全設置 canonical 標籤
        (function setCanonicalUrl(url: string): void {
            let link: HTMLLinkElement | null = document.querySelector('link[rel="canonical"]');
            if (!link) {
                link = document.createElement('link');
                link.rel = 'canonical';
                document.head.appendChild(link);
            }
            link.href = url;
        })(canonicalUrl);

        return true;
    } catch (e) {
        Common.ConsoleLog(e);
        return false;
    }
}

export default router;
